import { DataService } from './dataService'


export const UserEnquiryService ={
    getEnquiry: async (data) => {
        return DataService.get('/admin/user-enquiry/list', data)
    },
    updateEnquiryState: async (data) => {
             let url = '/admin/user-enquiry/update'
        let str = DataService.convertObjToQueryStr(data)
	    url = url+str;
        return DataService.put(url, data)
    },
    // addSubCategory: async (data) => {
    //     return DataService.post('admin/sub-category/create', data)
    // },
    getSingalEnquiry: async (data) => {
        // return DataService.get('/admin/user-enquiry/list', data)
        let url = '/admin/user-enquiry/list'
        let str = DataService.convertObjToQueryStr(data)
	    url = url+str;
        return DataService.get(url)
    },
	// updateCategory: async (data) => {
    //     let url = '/admin/sub-category/update'
    //     let str = DataService.convertObjToQueryStr(data)
	//     url = url+str;
    //     return DataService.put(url, data)
    // },
	// deleteCategory: async (data) => {
    //     return DataService.delete('admin/sub-category/delete?'+"id"+"="+data.id, data)
    // },
}